import { $qs , $qsa } from "../../../src/js/utils/querySelector"
import gsap from "gsap";

function exploreMore() {
    if($qsa('[data-block=explore-more]').length) {
        $qsa('[data-block=explore-more]').forEach((block) => {
            var links = $qsa('[data-link=explore-link]');
            [...links].forEach((link) => {   
                var number = link.getAttribute('data-target');
                var image = $qs('.explore-image-' + number);
                
                link.addEventListener('mouseenter', () => {
                    image.style.opacity = 1
                })
                link.addEventListener('mouseleave', () => {
                    image.style.opacity = 0
                })
            })
        })
    }
}

export default exploreMore;